module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_17-23f5092cd84ed5cf04613273e2705ca3.jpg";